import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { List as Desc } from './desk'
import { List as Mob } from './mob'

import { Props } from './types'

export const List: React.FC<Props> = (props) => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob {...props} /> : <Desc {...props} />
}
